const sectionClasses = 'mb-6';

const sectionHeadingClasses =
    'text-base font-bold uppercase tracking-wide text-content border-b border-border pb-1.5 mb-2 m-0';

const sectionBodyClasses = 'text-base leading-relaxed text-content whitespace-pre-line m-0';

const TextSection = ({ heading, body, trailing }) => (
    <div className={sectionClasses}>
        <h4 className={sectionHeadingClasses}>{heading}</h4>
        {body && <p className={sectionBodyClasses}>{body}</p>}
        {trailing}
    </div>
);

export default TextSection;
